export const DEFAULT_ORGANIZATION_SEARCH = { current: 1, pageSize: 20 } as const
